import { useParams } from "react-router";
import SampleProfile from "../SampleProfile/SampleProfile";


interface INewSampleProfileSavingsPlanProps {
    publicVersion: boolean;
}

const SampleProfileSavingsPlan = (props: INewSampleProfileSavingsPlanProps) => {
    const { sampleProfileId } = useParams<{ sampleProfileId: string }>();
    return (
        <SampleProfile 
            sampleProfileId={sampleProfileId!}
            publicVersion={props.publicVersion} />
    );
}

export default SampleProfileSavingsPlan;